import { render, staticRenderFns } from "./InterestNews.vue?vue&type=template&id=45693510&"
import script from "./InterestNews.vue?vue&type=script&lang=js&"
export * from "./InterestNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports